import { render } from "./App.vue?vue&type=template&id=4cbf9f4b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4cbf9f4b&lang=css"

import exportComponent from "E:\\progetti\\Python\\poltrone-e-sofa\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__